import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom"
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";


export default function PaymentSeccess() {

    const {id} = useParams();
    const [product,setProduct] = useState([])
    const {user} = useAuthContext()
    const [loading,setLoading] = useState(false)
    const navi = useNavigate()

    useEffect(() => {
        setLoading(true);
    
        const fetchProduct = async () => {
          try {
         
    
       
    
            const prodResponse = await axios.get(
              `${ApiConnectionString}/api/product/${id}`,
              {
                headers: { Authorization: `Bearer ${user.token}` },
              }
            );
          
            setProduct(prodResponse.data);
    
            setLoading(false);
          } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
          }
        };
    
        fetchProduct();
      }, [user]);


  return (
    <div className="container text-center my-5">
        <p>Your payment was successful</p>
        <p>A digital email has been to you.You can also keep track of payments and subscriptions on your <Link to="/myprofile">Profile Page</Link></p>
        <button className="btn btn-primary" onClick={() => navi("/")}>Return home</button>
    </div>
  )
}
